var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-container"},[_c('lottie',{attrs:{"options":_vm.lottieOptions},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }